import getConfig from "next/config"

const { publicRuntimeConfig, generateBuildId } = getConfig()

const appENV = publicRuntimeConfig.appENV
const sentryDSN = publicRuntimeConfig.sentryDSN
const buildId = generateBuildId || process.env.CONFIG_BUILD_ID

const basePath = publicRuntimeConfig.basePath

const webTrackDomain = publicRuntimeConfig.webTrackDomain
const webTrackFolderPath = publicRuntimeConfig.webTrackFolderPath
const webTrendsFolderPath = publicRuntimeConfig.webTrendsFolderPath
const webTrendsDCSIMGSrc = publicRuntimeConfig.webTrendsDCSIMGSrc
const minsForPaymentRetryTimeout = publicRuntimeConfig.minsForPaymentRetryTimeout
const ssoScriptUrl = publicRuntimeConfig.ssoScriptUrl
const footerScriptUrl = publicRuntimeConfig.footerScriptUrl
const preconnectAccountUrl = publicRuntimeConfig.preconnectAccountUrl
const tencentScriptUrl = publicRuntimeConfig.tencentScriptUrl
const googleRecaptchaUrl = publicRuntimeConfig.googleRecaptchaUrl

export default {
  appENV,
  sentryDSN,
  buildId,
  basePath,
  domain: webTrackDomain,
  path: webTrackFolderPath,
  webTrendsFolderPath,
  webTrendsDCSIMGSrc,
  minsForPaymentRetryTimeout,
  ssoScriptUrl,
  footerScriptUrl,
  preconnectAccountUrl,
  tencentScriptUrl,
  googleRecaptchaUrl
}
